import { FC } from 'react'
import ImportsList from '../components/import/ImportsList'
import useImports from '../hooks/useImports'
import usePagable from '../hooks/usePagable'
import Page from '../layout/Main/Page'
import { importApi } from '../services/import.api'
import { IPagableRequest } from '../services/IPagable'
import { iniTImportsFilterState, TImportsFilterState } from '../store/importsSlice'

const ImportsPage: FC = () => {
  const { importsFilter, setFilterParams } = useImports({})
  const { pagable, pagableState, onSort, loadTriggerComponent, updatePagableApiState } = usePagable(
    {
      initPagable: {
        size: 100,
        sort: 'createdAt',
        sortDirection: 'desc',
      },
      filterMap: importsFilter,
      allowUrlFilterArr: Object.keys(iniTImportsFilterState),
      setFilterParams,
    },
  )

  // -- Load imports catalog
  const {
    data: imports,
    isFetching,
    isLoading,
  } = importApi.useGetImportsMergeQuery(pagableState as IPagableRequest<TImportsFilterState>, {
    skip: !pagableState,
  })

  return (
    <Page
      header={{
        title: `Imports`,
        subTitle: 'All Imports',
      }}
    >
      <ImportsList
        imports={imports?.content}
        pagable={pagable}
        // isPending={isFetching || isLoading}
        // onDelete?: (import: IImport) => unknown,
        loadTriggerComponent={loadTriggerComponent}
        onSort={onSort}
      />
    </Page>
  )
}

export default ImportsPage
